import React, { useState } from 'react';

export const Download = () => {
  const macCurlDownloadCmd = 'curl -LO "https://github.com/vaidkaran/effortless_electron/releases/download/v1.0.6/effortless_electron-1.0.6-arm64.dmg"';
  const macWgetDownloadCmd = 'wget "https://github.com/vaidkaran/effortless_electron/releases/download/v1.0.6/effortless_electron-1.0.6-arm64.dmg"';

  const [copiedCommand, setCopiedCommand] = useState(null);

  const handleCopy = (command) => {
    navigator.clipboard.writeText(command).then(() => {
      setCopiedCommand(command);
      setTimeout(() => setCopiedCommand(null), 2000);
    });
  };

  return (
    <div id="download" style={{ paddingTop: 100 }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Download the App</h2>

        {/* Security Warning */}
        <div style={{ padding: '1rem', borderLeft: '5px solid #ffc107', marginBottom: '2rem' }}>
          <strong>⚠️ You Might See a Security Warning</strong>
          <p>
            Since this project is still in an early stage, we haven’t purchased a digital certificate yet (they're expensive!).
            That means your operating system may show a warning saying the app is from an <em>“Unknown Publisher”</em>
          </p>
          <p>
            Know that the OS is just warning you because the app isn’t digitally signed — it doesn’t mean the app is unsafe.
          </p>
          <p>
            For your peace of mind, here’s the antivirus scan results: <a href="antivirus-scan.pdf" target="_blank" rel="noopener noreferrer">View Report</a>
          </p>
        </div>

        {/* Windows / macOS / Linux Sections */}
        <div style={{
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '2rem',
          marginBottom: '3rem',
          backgroundColor: '#f9f9f9'
        }}>
          <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
            
            {/* Windows Section */}
            <div style={{ flex: 1, minWidth: '300px' }}>
              <h3><img height={20} width={20} src={'./img/windows.png'} alt='' /> Windows</h3>
              <p><strong>Download Link:</strong> <a href="https://github.com/vaidkaran/effortless_electron/releases/download/v1.0.6/effortless_electron-1.0.6.Setup.exe" target="_blank" rel="noopener noreferrer">Download for Windows</a></p>
              <ol>
                <li>Double-click the installer file</li>
                <li>You’ll see a Windows SmartScreen warning: “Windows protected your PC”</li>
                <li>Click <strong>More Info</strong></li>
                <li>Click the <strong>Run Anyway</strong> button</li>
              </ol>

              {/* Separator and Linux section */}
              <hr style={{ margin: '2rem 0' }} />
              <h3><img height={20} width={20} src={'./img/linux-logo.png'} alt='' /> Linux (Ubuntu)</h3>
              <p><strong>Download Link:</strong> <a href="https://github.com/vaidkaran/effortless_electron/releases/download/v1.0.6/effortless-electron_1.0.6_amd64.deb" target="_blank" rel="noopener noreferrer">Download for Ubuntu</a></p>
            </div>

            {/* macOS Section */}
            <div style={{ flex: 1, minWidth: '300px', paddingLeft: '2rem', borderLeft: '1px solid #ccc' }}>
              <h3><img height={20} width={20} src={'./img/apple-logo.png'} alt='' /> macOS</h3>
              <p><strong>Download via Terminal:</strong></p>

              {/* curl */}
              <div style={{ position: 'relative', marginBottom: 5 }}>
                <pre style={{ backgroundColor: '#f4f4f4', padding: '1rem', marginBottom: 0 }}>{macCurlDownloadCmd}</pre>
                <button
                  onClick={() => handleCopy(macCurlDownloadCmd)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '10px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem'
                  }}
                  title="Copy to clipboard"
                >
                  <img height={20} width={20} src={'./img/copy.png'} alt='' />
                </button>
                {copiedCommand === macCurlDownloadCmd && <span style={{ color: 'green', marginLeft: '1rem' }}>Copied!</span>}
              </div>

              Or
              {/* wget */}
              <div style={{ position: 'relative', marginTop: '5px', marginBottom: 5 }}>
                <pre style={{ backgroundColor: '#f4f4f4', padding: '1rem', marginBottom: 0 }}>{macWgetDownloadCmd}</pre>
                <button
                  onClick={() => handleCopy(macWgetDownloadCmd)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '10px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem'
                  }}
                  title="Copy to clipboard"
                >
                  <img height={20} width={20} src={'./img/copy.png'} alt='' />
                </button>
                {copiedCommand === macWgetDownloadCmd && <span style={{ color: 'green', marginLeft: '1rem' }}>Copied!</span>}
              </div>

              Double click the file for installation as usual
            </div>
          </div>
        </div>

        {/* Browser Usage Section */}
        <div>
          <h3>🌐 Use in Your Browser</h3>
          <p><strong>Access:</strong> <a href="https://effortless-test-fe.vercel.app" target="_blank" rel="noopener noreferrer">effortless-test-fe.vercel.app</a></p>

          <div style={{ padding: '1rem', borderLeft: '5px solid #dc3545', marginTop: '1rem' }}>
            <strong>⚠️ CORS Notice for Browser Usage</strong>
            <p>
              You can also access the app directly via browser — no installation needed!
              But browser usage comes with <strong>CORS-related limitations</strong>.
            </p>
            <p>
              If your own backend API (which you’re going to write tests for) does not include CORS headers for this origin,
              requests will be blocked by the browser.
            </p>
            <p>If you’re just trying things out, try testing these free public APIs that work great:
              <a href='https://jsonplaceholder.typicode.com/'> JSONPlaceholder, </a>
              <a href='https://reqres.in/'>Reqres</a>
            </p>
            <p>If you still want to write tests for your backend API in browser mode:</p>
            <ul>
              <li>Enable CORS for <code>effortless-test-fe.vercel.app</code> in your API server configuration</li>
              <li>Alternatively, use a proxy server or CORS middleware (e.g., <code>cors</code> in Express.js)</li>
            </ul>
            <p><strong>For the full experience (with no CORS limitations), we recommend downloading and using the desktop app.</strong></p>
          </div>
        </div>
      </div>
    </div>
  );
};
